<template>
  <path pid="0" d="M21 9h-1V3a1 1 0 00-1-1H6.88A1 1 0 006 3v6H5a3 3 0 00-3 3v5.18A3 3 0 005 20h1v3a1 1 0 001 1h12a1 1 0 001-1v-3h1a3 3 0 003-3v-5.18A3 3 0 0021 9zM8 4h10v5H8zm10 18H8v-6h10zm4-5v.12a1 1 0 01-1 .88h-1v-3a1 1 0 00-1-1H7a1 1 0 00-1 1v3H5a1 1 0 01-1-1v-5a1 1 0 011-1h16a1 1 0 011 1z"/>
</template>
